<template>
    <div>
        <a-form class="mt30 retrieve-form-item" ref="ruleForm" :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
            <slot name="header"></slot>
            <div v-for="(item, index) in formList" :key="index">
                <!-- 不可以是服务协议通知 二级隐藏 一级直接显示 或者 如果符合条件则显示 -->
                <template v-if="showFormItemFun(item)">
                    <!-- 手机号 -->
                    <template v-if="item.field_code == 'mobile'">
                        <!-- 防止表单自动填充问题 -->
                        <div style="position: fixed; right: -99999px; top: -99999px">
                            <input type="text" name="mobile" />
                            <input type="text" name="email" />
                            <input type="password" name="password" />
                        </div>
                        <!-- 防止表单自动填充问题 -->
                        <a-form-item :label="item.field_display">
                            <div slot="extra" class="fs12 g_error" v-if="item.hint">{{ item.hint }}</div>
                            <a-input
                                type="text"
                                @blur="handleRegPhoneEvent($event, 'mobile', item.language)"
                                :disabled="mobileDisabled !== null ? mobileDisabled : !is_reg"
                                autocomplete="off"
                                :placeholder="item.hint_null"
                                v-decorator="[
                                    item.field_code,
                                    {
                                        rules: [
                                            { required: true, message: item.hint_null },
                                            { pattern: new RegExp(/^1[\d]{10}$/), message: item.hint_verify_no }
                                        ],
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <!-- <a-button v-if="is_change_mobile" type="primary" class="code-btn" slot="addonAfter">
                                    <router-link :to="`/personal/pwd-phone/${$route.params.lang}/${$route.params.meeting_id}`">修改绑定手机</router-link>
                                </a-button> -->
                            </a-input>
                        </a-form-item>
                        <!-- 注册表单中需要添加验证码，密码，确认密码 -->
                        <template v-if="is_reg">
                            <a-form-item v-if="item.custom == 1" :label="$t('formConfig.sms_verification' /* 短信验证 */)">
                                <a-input
                                    autocomplete="off"
                                    class="phone-btn-show"
                                    :placeholder="$t('formConfig.please_enter_the_verification_code' /* 请输入验证码 */)"
                                    v-decorator="['smscaptcha', { rules: [{ required: true, message: $t('formConfig.please_enter_the_verification_code' /* 请输入验证码 */) }] }]"
                                >
                                    <a-button type="primary" class="code-btn" slot="addonAfter" :disabled="disabled" @click="handleSendSmsEvent">
                                        {{ codetext }}
                                    </a-button>
                                </a-input>
                            </a-form-item>
                            <a-form-item :label="$t('formConfig.set_password' /* 设置密码 */)">
                                <a-input
                                    type="password"
                                    autocomplete="off"
                                    :placeholder="$t('formConfig.please_enter_password' /* 请输入密码 */)"
                                    v-decorator="[
                                        'password',
                                        {
                                            rules: [
                                                { required: true, message: $t('formConfig.password_cannot_be_empty' /* 密码不能为空 */) },
                                                {
                                                    pattern: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,}$/,
                                                    message: $t(
                                                        'formConfig.password_must_be_a_combination_of_letters_lowercase_numbers_uppercase_special_characters_and_at_least_6_characters' /* 密码必须是字母小写、数字、字母大写、特殊字符中任意两种组合，且不能少于6位！ */
                                                    )
                                                }
                                            ],
                                            trigger: 'blur'
                                        }
                                    ]"
                                />
                            </a-form-item>
                            <a-form-item :label="$t('formConfig.confirm_password' /* 确认密码 */)">
                                <a-input
                                    type="password"
                                    autocomplete="off"
                                    :placeholder="$t('formConfig.please_confirm_password' /* 请确认密码 */)"
                                    v-decorator="[
                                        're_password',
                                        { rules: [{ required: true, message: $t('formConfig.password_cannot_be_empty' /* 密码不能为空 */) }, { validator: confirmPasswordFun }], trigger: 'blur' }
                                    ]"
                                />
                            </a-form-item>
                        </template>
                    </template>

                    <!-- 邮箱 -->
                    <template v-else-if="item.field_code == 'email'">
                        <a-form-item :label="item.field_display">
                            <div slot="extra" class="fs12 g_error" v-if="item.hint">{{ item.hint }}</div>
                            <a-input
                                type="text"
                                @blur="handleRegPhoneEvent($event, 'email', item.language)"
                                :disabled="emailDisabled"
                                autocomplete="off"
                                :placeholder="item.hint_null"
                                v-decorator="[
                                    item.field_code,
                                    {
                                        rules: [
                                            { required: true, message: item.hint_null },
                                            {
                                                pattern: /^[a-zA-Z0-9.!#$%&\'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                                                message: item.hint_verify_no
                                            }
                                        ],
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <!-- <a-button v-if="is_change_email" type="primary" class="code-btn" slot="addonAfter">
                                    <router-link :to="`/personal/pwd-email/${$route.params.lang}/${$route.params.meeting_id}`">修改绑定邮箱</router-link>
                                </a-button> -->
                            </a-input>
                        </a-form-item>
                    </template>

                    <!-- 身份证 -->
                    <template v-else-if="item.field_code == 'cardno'">
                        <a-form-item :label="item.field_display">
                            <div slot="extra" class="fs12 g_error" v-if="item.hint">{{ item.hint }}</div>
                            <a-input
                                type="text"
                                autocomplete="off"
                                :placeholder="item.hint_null"
                                v-decorator="[
                                    item.field_code,
                                    item.is_null == 1
                                        ? {
                                              rules: [
                                                  { required: true, message: item.language == 'cn' ? '身份证号格式不正确' : 'ID card number format is incorrect' },
                                                  { validator: checkCardnoValidator }
                                              ],
                                              trigger: 'blur'
                                          }
                                        : {}
                                ]"
                            />
                        </a-form-item>
                    </template>

                    <!-- 国家 或 省市区 -->
                    <select-city
                        v-else-if="item.field_type == 'region'"
                        :dataValue="citySelectData"
                        :needCountry="item.language == 'en' ? 1 : 2"
                        :countryLabel="item.field_display"
                        :countryHint="item.hint_null"
                    ></select-city>

                    <!-- 技术职称 三级联动 -->
                    <select-teaching
                        v-else-if="item.field_type == 'teaching_title'"
                        :dataValue="teachingData"
                        :options="JSON.parse(item.options)"
                        :teachingLabel="item.field_display"
                        :teachingHint="item.hint_null"
                    ></select-teaching>

                    <!-- 其他字段 -->
                    <a-form-item v-else :label="item.field_display">
                        <div slot="extra" class="fs12 g_error" v-if="item.hint">{{ item.hint }}</div>

                        <!-- 普通文本框text -->
                        <a-input
                            v-if="item.field_type == 'text' && item.field_code != 'birthdate'"
                            type="text"
                            autocomplete="off"
                            :placeholder="item.hint_null"
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                        />

                        <!-- 多行文本框textarea -->
                        <a-input
                            v-if="item.field_type == 'textarea' && item.field_code != 'resume'"
                            type="textarea"
                            autocomplete="off"
                            :placeholder="item.hint_null"
                            :auto-size="{ minRows: 3, maxRows: 3 }"
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                        />
                        <!-- 富文本编辑器 -->
                        <tinymce-editor
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                            :lengthType="item.field_type == 'abstract' ? 2 : 1"
                            v-if="item.field_type == 'abstract' || (item.field_type == 'textarea' && item.field_code == 'resume')"
                        ></tinymce-editor>

                        <!-- 单选框radio -->
                        <a-radio-group v-if="item.field_type == 'radio'" v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]">
                            <template v-if="item.field_code == 'jcsq' || item.field_code == 'xcys'">
                                <a-radio v-for="(it, idx) in item.options" :key="'radio' + idx" :value="it == '是' ? '1' : '0'">{{ it }}</a-radio>
                            </template>
                            <!-- 学分 -->
                            <template v-else-if="item.field_code == 'score_type'">
                                <a-radio value="1">{{ item.language == 'cn' ? '是' : 'yes' }}</a-radio>
                                <a-radio value="0">{{ item.language == 'cn' ? '否' : 'no' }}</a-radio>
                            </template>
                            <!-- 签到 -->
                            <template v-else-if="item.field_code == 'is_reg'">
                                <a-radio value="1">{{ item.language == 'cn' ? '已签到' : 'Signed in' }}</a-radio>
                                <a-radio value="0">{{ item.language == 'cn' ? '未签到' : 'Not signed in' }}</a-radio>
                            </template>
                            <template v-else>
                                <a-radio v-for="(it, idx) in item.options" :key="'radio' + idx" :value="it">{{ it }}</a-radio>
                            </template>
                        </a-radio-group>

                        <!-- 多选框checkbox -->
                        <a-checkbox-group v-if="item.field_type == 'checkbox'" v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]">
                            <a-checkbox v-for="(it, idx) in item.options" :key="'checkbox' + idx" :value="it">{{ it }}</a-checkbox>
                        </a-checkbox-group>

                        <!-- 分支机构 -->
                        <a-select
                            :mode="item.big_astrict > 1 ? 'multiple' : 'default'"
                            v-if="item.field_type == 'select' && item.field_code == 'committee_branch'"
                            v-decorator="[
                                item.field_code,
                                {
                                    rules: [
                                        { required: item.is_null == 1, message: item.hint_null },
                                        {
                                            validator: (rule, value, callback) => {
                                                checkMaxSelectedNumber(item, rule, value, callback);
                                            }
                                        }
                                    ]
                                }
                            ]"
                        >
                            <a-select-option v-for="(it, idx) in branchList" :key="'select-multiple' + idx" :value="String(it.id)">{{ it.name }}</a-select-option>
                        </a-select>

                        <!-- 现场工作岗位 -->
                        <a-select
                            v-else-if="item.field_type == 'select' && item.field_code == 'onsite_department'"
                            mode="default"
                            v-decorator="[
                                item.field_code,
                                {
                                    rules: [
                                        { required: item.is_null == 1, message: item.hint_null },
                                        {
                                            validator: (rule, value, callback) => {
                                                checkMaxSelectedNumber(item, rule, value, callback);
                                            }
                                        }
                                    ]
                                }
                            ]"
                        >
                            <a-select-option v-for="(it, idx) in staffList?.staff_post" :key="'select' + idx" :value="it.value">{{ it.name }}</a-select-option>
                        </a-select>

                        <!-- 工作人员身份 -->
                        <a-select
                            v-else-if="item.field_type == 'select' && item.field_code == 'staff_type'"
                            mode="default"
                            v-decorator="[
                                item.field_code,
                                {
                                    rules: [
                                        { required: item.is_null == 1, message: item.hint_null },
                                        {
                                            validator: (rule, value, callback) => {
                                                checkMaxSelectedNumber(item, rule, value, callback);
                                            }
                                        }
                                    ]
                                }
                            ]"
                        >
                            <a-select-option v-for="(it, idx) in staffList?.staff_type" :key="'select' + idx" :value="`${it.value}`">{{ it.name }}</a-select-option>
                        </a-select>

                        <!-- 下拉选择框select -->
                        <a-select
                            :mode="item.big_astrict > 1 ? 'multiple' : 'default'"
                            v-else-if="item.field_type == 'select'"
                            v-decorator="[
                                item.field_code,
                                {
                                    rules: [
                                        { required: item.is_null == 1, message: item.hint_null },
                                        {
                                            validator: (rule, value, callback) => {
                                                checkMaxSelectedNumber(item, rule, value, callback);
                                            }
                                        }
                                    ]
                                }
                            ]"
                        >
                            <a-select-option v-for="(it, idx) in item.options" :key="'select' + idx" :value="String(it)">{{ it }}</a-select-option>
                        </a-select>

                        <!-- 日历date -->
                        <a-date-picker
                            v-if="item.field_type == 'date' || (item.field_type == 'text' && item.field_code == 'birthdate')"
                            :placeholder="item.hint_null"
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                        />

                        <!-- 上传视频 -->
                        <a-upload
                            v-if="item.field_code == 'abstract_annex' && item.field_type == 'file'"
                            name="Filedata"
                            accept="video/*"
                            :data="{ ...uploadVideoData, file_type: item.field_code }"
                            :fileList="item.fileList || []"
                            list-type="picture"
                            :action="uploadVideoUrl"
                            :before-upload="info => beforeUpload(info, item)"
                            @change="handleUploadVideoEvent($event, item)"
                        >
                            <input type="hidden" v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]" />
                            <a-button type="primary" icon="upload" :loading="item.loading" :disabled="item.loading" class="mr10 mb10">
                                {{ item.language == 'cn' ? '上传' : 'Upload ' + item.field_display }}
                            </a-button>
                        </a-upload>

                        <!-- 上传文件file -->
                        <a-upload
                            v-else-if="item.field_type == 'image' || item.field_type == 'file'"
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :action="uploadImageUrl"
                            :data="{ type: 1 }"
                            :before-upload="info => beforeUpload(info, item)"
                            :headers="uploadHeaders"
                            @change="handleChange($event, item)"
                        >
                            <input type="hidden" v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]" />
                            <a-spin v-if="form.getFieldValue(item.field_code)" :spinning="item.loading">
                                <img style="max-width: 100%" :src="form.getFieldValue(item.field_code) | urlFilter(250)" alt="file" />
                            </a-spin>
                            <div v-else>
                                <a-icon :type="item.loading ? 'loading' : 'plus'" />
                                <div class="ant-upload-text">{{ item.language == 'cn' ? '上传' : 'Upload ' + item.field_display }}</div>
                            </div>
                        </a-upload>
                    </a-form-item>
                </template>
            </div>
        </a-form>
    </div>
</template>

<script>
import tinymceEditor from '@/components/Tinymce/index.vue';
import userApi from '@/request/apiList';
import selectCity from '@/components/select-city.vue';
import selectTeaching from '@/components/select-teaching.vue';
import storage from 'store';
import moment from 'moment';
export default {
    name: 'RegisterForm',
    props: {
        staffList: {
            type: Object,
            default: () => {}
        },
        // 手机号是否disabled (如果是null这相当于参数未设置，如果是true或者false这已当前参数为准)
        mobileDisabled: {
            type: [Boolean, Object],
            default: null
        },
        // 邮箱是否disabled
        emailDisabled: {
            type: Boolean,
            default: false
        },
        // 是否为注册
        is_reg: {
            type: Boolean,
            default: false
        },
        // 表单列表
        list: {
            type: Array,
            default: () => []
        },
        model: {
            type: Object,
            default: () => null
        },
        // 是否可以更改手机号
        is_change_mobile: {
            type: Boolean,
            default: false
        },
        // 是否可以更改邮箱
        is_change_email: {
            type: Boolean,
            default: false
        },
        // en  cn
        lang: {
            type: String,
            default: (() => {
                return storage.get('lang');
            })()
        }
    },
    data() {
        return {
            // 文件请求头
            uploadHeaders: {},
            // 文件请求地址
            uploadImageUrl: userApi.uploadImage,
            form: this.$form.createForm(this),
            // 自定义表单列表
            formList: [],
            // 城市选择回显数据
            citySelectData: {},
            // 职称三级联动回显
            teachingData: {},
            // 上传视频的参数
            uploadVideoData: {
                meeting_id: 0
            },
            // 上传视频的地址
            uploadVideoUrl: userApi.uploadVideo,
            // 验证码相关
            codetext: this.$t('web.get_verification_code' /* 获取验证码 */),
            disabled: false,

            // 表单响应式布局
            labelCol: (() => {
                let lang = this.$storage.get('lang');
                return lang == 'en' ? { xs: { span: 24 }, sm: { span: 7 }, xl: { span: 5 } } : { xs: { span: 24 }, sm: { span: 5 }, xl: { span: 4 } };
            })(),
            wrapperCol: (() => {
                let lang = this.$storage.get('lang');
                return lang == 'en' ? { xs: { span: 24 }, sm: { span: 17 }, xl: { span: 19 } } : { xs: { span: 24 }, sm: { span: 19 }, xl: { span: 20 } };
            })(),

            // 分会列表
            branchList: []
        };
    },

    watch: {
        // 自定义表单
        list: {
            handler(newVal) {
                if (!newVal.length) return;
                let formList = [];
                const newValues = JSON.parse(JSON.stringify(newVal));
                newValues.forEach(item => {
                    if (item.options) {
                        item.options = item.options.split('|');
                    }
                    // 增加上传文件的loading参数
                    if (item.field_type == 'image' || item.field_type == 'file') {
                        item.loading = false;
                    }

                    // 分会下拉选项单独处理
                    if (item.field_code == 'committee_branch') {
                        this.getBranchList();
                    }

                    // 数据回显
                    this.showDataFun(this.model, item);

                    // 避免更新item时触发list的监听事件
                    formList.push(JSON.parse(JSON.stringify(item)));
                });
                this.formList = formList;
            },
            immediate: true
        },

        // 监听model
        model: {
            handler(newVal) {
                if (newVal) {
                    // 城市数据回显
                    this.citySelectData = { country_id: newVal.country_id, province_id: newVal.province_id, city_id: newVal.city_id, area_id: newVal.area_id };
                    this.teachingData = {
                        teaching_title_reg: newVal.teaching_title_reg,
                        teaching_title_reg_new1: newVal.teaching_title_reg_new1,
                        teaching_title_reg_qita: newVal.teaching_title_reg_qita
                    };
                    this.formList.forEach(item => {
                        // 数据回显
                        this.showDataFun(newVal, item);
                    });
                }
            },
            immediate: true
        }
    },

    components: {
        selectCity,
        tinymceEditor,
        selectTeaching
    },

    computed: {},
    created() {
        // 防止表单未注册
        // fields.forEach(v => this.form.getFieldDecorator(v))
    },
    methods: {
        // 是否显示当前表单
        showFormItemFun(item) {
            let parent_code = item.parent_code && this.form.getFieldValue(item.parent_code);
            if (Array.isArray(parent_code)) {
                parent_code = parent_code.join('|');
            }
            return item.field_code != 'notice' && (item.parent_id == 0 || !item.parent_id || parent_code == item.parent_value);
        },

        // 获取分会数据
        getBranchList() {
            this.$request.get({ url: 'getBranchList' }).then(res => {
                this.branchList = res.data;
            });
        },

        // 数据回显方法
        showDataFun(data, item) {
            // 注册
            this.form.getFieldDecorator(item.field_code, { preserve: true });
            // 赋值
            if (data) {
                let fieldForm = {};
                // 多选框回显
                if (item.field_type == 'checkbox' || (item.field_type == 'select' && item.big_astrict > 1)) {
                    data[item.field_code] && (fieldForm[item.field_code] = data[item.field_code].split('|'));
                    // 日期格式回显
                } else if (item.field_type == 'date' || (item.field_type == 'text' && item.field_code == 'birthdate')) {
                    data[item.field_code] && (fieldForm[item.field_code] = moment(data[item.field_code]));
                } else {
                    data[item.field_code] && (fieldForm[item.field_code] = data[item.field_code]);
                }
                this.form.setFieldsValue(fieldForm);
            }
        },

        // 上传视频
        handleUploadVideoEvent(info, currItem) {
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
            fileList = fileList.map(file => {
                if (file.response) {
                    currItem.loading = true;
                    let { response } = file;
                    response = JSON.parse(response.substr(1, response.length - 2));
                    let { code, relative_path, absolute_path } = response;
                    if (code == 0) {
                        file.url = absolute_path;
                        this.form.setFieldsValue({
                            [currItem.field_code]: relative_path
                        });
                    }
                    currItem.loading = false;
                }
                return file;
            });

            if (!fileList.length) {
                this.form.setFieldsValue({
                    [currItem.field_code]: ''
                });
            }
            this.$set(currItem, 'fileList', fileList);
        },

        // 上传修改
        handleChange(info, currItem) {
            if (info.file.status === 'uploading') {
                currItem.loading = true;
                return;
            }
            if (info.file.status === 'done') {
                let { code, data, message } = info.file.response;
                if (code == 200) {
                    let obj = {};
                    obj[currItem.field_code] = data.relative_path;
                    this.form.setFieldsValue(obj);
                } else {
                    this.$message.error(message);
                }
                currItem.loading = false;
            }
        },

        // 上传前
        beforeUpload(file, currItem) {
            let regFile = true;
            // 头像的验证
            if (currItem.field_type == 'image') {
                let regFile = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
                if (!regFile) {
                    this.$message.error(currItem.language == 'cn' ? '您只能上传图像文件' : 'You can only upload image files');
                    return regFile;
                }
            }
            // 其他文件的验证
            if (currItem.field_type == 'file') {
                // 取后台上传的后缀配置
                let options = currItem.options || [];
                // 获取当前上传的文件后缀
                let suffix = file.name.split('.');
                suffix = suffix[suffix.length - 1];
                if (options.length && options.indexOf(suffix) == -1) {
                    regFile = false;
                    this.$message.error(currItem.language == 'cn' ? `请上传后缀为${options.join('|')}的格式` : 'Please upload a file in ' + options.join('|') + ' format');
                    return regFile;
                }
            }
            return regFile;
        },

        // 获取手机验证码
        handleSendSmsEvent() {
            let mobile = this.form.getFieldValue('mobile');
            if (mobile && /^1[\d]{10}$/.test(mobile)) {
                this.$request.post({ url: 'meetingSendSms', data: { mobile, sms_type: 2 } }).then(res => {
                    let wait = 60;
                    this.disabled = true;
                    this.timer = setInterval(() => {
                        wait--;
                        this.codetext = wait + this.$t('web.seconds_later_resend' /* s后重发 */);
                        if (wait == 0) {
                            clearInterval(this.timer);
                            wait = 60;
                            this.disabled = false;
                            this.codetext = this.$t('web.get_verification_code' /* 获取验证码 */);
                        }
                    }, 1000);
                });
            } else {
                this.$message.error(this.$t('formConfig.please_enter_mobile_number' /* 请输入手机号码 */));
            }
        },

        // 确认密码
        confirmPasswordFun(rule, value, callback) {
            const form = this.form;
            if (value && value !== form.getFieldValue('password')) {
                callback(this.$t('formConfig.you_two_input_passwords_are_not_the_same' /* 您两次输入的密码不一致！ */));
            } else {
                callback();
            }
        },

        // 验证最大选择数量
        checkMaxSelectedNumber(item, rule, value, callback) {
            if (item.big_astrict > 1) {
                if (value.length > item.big_astrict) {
                    callback(this.$t('formConfig.the_selected_number_cannot_exceed', { count: item.big_astrict } /* 选择的数量不能超过{count}条 */));
                    return false;
                }
                callback();
            }
            callback();
        },

        // 身份证验证
        checkCardnoValidator(rule, value, callback) {
            if (!value) {
                // 因为已经有requred提示了，所以这里就不需要其他提示了
                callback('');
                return false;
            }
            // 港澳台不校验身份证
            let provinceId = this.form.getFieldValue('province_id');
            if (provinceId != '3714' && provinceId != '3795' && provinceId != '3799') {
                if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                    callback('身份证号格式不正确');
                    return false;
                }
            }
            //18位身份证需要验证最后一位校验位
            if (value.length == 18) {
                let code = value.split('');
                //∑(ai×Wi)(mod 11)
                //加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                //校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                var sum = 0;
                var ai = 0;
                var wi = 0;
                for (var i = 0; i < 17; i++) {
                    ai = code[i];
                    wi = factor[i];
                    sum += ai * wi;
                }
                var last = parity[sum % 11];
                if (parity[sum % 11] != code[17]) {
                    callback('身份证号不正确');
                    return false;
                }
                callback();
            }
            callback();
        },

        // 手机号验证
        handleRegPhoneEvent(e, field, language) {
            let { value } = e.target;
            //是否为手机号码
            let lang = this.$storage.get('lang');
            // 手机号不让修改的情况下拒绝验证
            if (field == 'mobile' && this.mobileDisabled) {
                return false;
            }
            if (lang == 'en') {
                // 拒绝验证
                if (field == 'mobile') {
                    return false;
                }
                //是否为邮箱
                if (!/(^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)/.test(value)) {
                    this.$message.error(language == 'cn' ? '账号格式不正确！' : 'The account format is incorrect!');
                    return false;
                }
            } else {
                // 拒绝验证
                if (field == 'email') {
                    return false;
                }
                // 是否为手机号
                if (!/(^1[\d]{10}$)/.test(value)) {
                    this.$message.error(language == 'cn' ? '账号格式不正确！' : 'The account format is incorrect!');
                    return false;
                }
            }

            this.$request.post({ url: 'getEmailMobile', data: { username: value }, costom: { hideModal: true } }).then(res => {
                // 如果已存在账户
                if (res.code == 200) {
                    this.$confirm({
                        title: '',
                        content:
                            language == 'cn'
                                ? '该手机号码已经存在，请使用该手机号码直接登录或找回密码！'
                                : 'The mobile number already exists, please use the mobile number to login or retrieve the password!',
                        okText: language == 'cn' ? '立即登录' : 'Immediately login',
                        cancelText: language == 'cn' ? '找回密码' : 'Retrieve password',
                        onOk: () => {
                            this.$router.replace({
                                path: `/login/${this.$route.params.committee_id}?m=${value}&redirect=${this.$route.redirect || ''}`
                            });
                        },
                        onCancel: () => {
                            this.$router.replace({
                                path: `/retrieve/${this.$route.params.committee_id}?m=${value}&redirect=${this.$route.redirect || ''}`
                            });
                        }
                    });
                }
            });
        }
    },

    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');

        // 投稿表单中的上传视频中使用
        // let { abstract_id } = this.$route.query;
        // if (abstract_id) {
        //     this.uploadVideoData['code'] = abstract_id;
        // }
    }
};
</script>
<style lang="less" scoped>
.reg-title {
    border-bottom: 1px solid #ddd;
}
.avatar-uploader {
    /deep/.ant-spin-container {
        position: relative;
        overflow: hidden;
        &:before {
            opacity: 0;
            content: 'change';
            position: absolute;
            left: 0;
            top: 0;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
        }
        &:hover {
            &:before {
                opacity: 1;
                z-index: 1;
            }
        }
    }
}
.retrieve-form-item {
    /deep/.ant-input {
        height: 36px;
    }

    /deep/.ant-input-group-addon {
        padding: 0;
    }
    .register-type {
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: @gap;
    }
    //.active {
    //    border-color: @theme;
    //   background: #fff url("~@/assets/images/select-icon.png") no-repeat right
    //        100%;
    //    background-size: 37.5px;
    //}
    .code-btn {
        height: 35px;
        border-radius: 0;
        display: block;
    }
}
@media screen and (max-width: 576px) {
    .retrieve-form-item {
        padding: 0;
    }
}
</style>
